import type { Language } from '@/i18n';

/**
 * Утилита для программных переводов
 * @param ru - текст на русском языке
 * @param en - текст на английском языке  
 * @param language - текущий язык
 * @returns переведенный текст
 */
export const tr = (ru: string, en: string, language: Language): string => {
  return language === 'ru' ? ru : en;
};

/**
 * Утилита для работы с объектами БД, содержащими поля с суффиксами Ru/En
 * @param item - объект с полями nameRu, nameEn и т.д.
 * @param fieldName - базовое имя поля без суффикса
 * @param language - текущий язык
 * @returns значение поля на текущем языке
 */
export const trDb = <T extends Record<string, any>>(
  item: T, 
  fieldName: string, 
  language: Language
): string | string[] => {
  const ruField = `${fieldName}_ru`;
  const enField = `${fieldName}_en`;
  
  if (language === 'ru') {
    return item[ruField] || item[enField] || '';
  } else {
    return item[enField] || item[ruField] || '';
  }
};